import { apiSlice } from "../../api/apiSlice";

export const suggestedSearchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSuggestedSearches: builder.query({
      query: ({ limit, page, search, type }) => {
        const params = new URLSearchParams({
          page: String(page),
          limit: String(limit),
          search: search || "",
        });
        if (type) {
          params.set("type", type);
        }
        return `/api/v1/admin/suggested-search/listing?${params.toString()}`;
      },
      providesTags: ["SuggestedSearch"],
    }),
    getSuggestedSearchById: builder.query({
      query: (id) => `/api/v1/admin/suggested-search/${id}`,
      providesTags: (result, error, id) => [{ type: "SuggestedSearch", id }],
    }),
    createSuggestedSearch: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/suggested-search",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["SuggestedSearch"],
    }),
    updateSuggestedSearch: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/v1/admin/suggested-search/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["SuggestedSearch"],
    }),
    deleteSuggestedSearch: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/suggested-search/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SuggestedSearch"],
    }),
  }),
});

export const {
  useGetSuggestedSearchesQuery,
  useGetSuggestedSearchByIdQuery,
  useCreateSuggestedSearchMutation,
  useUpdateSuggestedSearchMutation,
  useDeleteSuggestedSearchMutation,
} = suggestedSearchApiSlice;
